import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from "react-redux";
import GoogleMapReact from 'google-map-react';
import PUIcon from '../../assets/Images/MapImages/PUMarker.png'; // Correct path to your stop icon
import hull from 'hull.js'; // Import the convex hull library
import stopIcon from '../../assets/Images/locationicon.png'; 
import APICom from "../../utils/helpers/APICom.js";

// Custom marker component
const StopMarker = ({ icon }) => (
  <div>
    <img src={stopIcon} alt="Stop Icon" style={{ width: '10px', height: '10px' }} />
  </div>
);

const RCZControlMap = forwardRef(({ initialStops, center, zoom , onSave, nameOfCityCounty, IsSearchButtonClicked, 
  IsResetBtnClicked, onSearchComplete, onResetComplete, plottedStops,
    AddressComponentData, IsReloadStopsButtonClicked, onReloadStopsComplete, 
    SavedPolygone, onStopsLoadedFromAPI
    }, ref) => {
    const [stops, setStops] = useState(initialStops); // Manage stops locally
    const [map, setMap] = useState(null);
    const [polygon, setPolygon] = useState(null);
    const mapRef = useRef(null);
    const [busStops, setBusStops] = useState([]);
    // const { GlobalASCSData, ASCSSettingData, DispatchVehicleData, AffiliateData, FundingSourceData, ZoneVerticesData, 
    //   VirtualStopsData, RCZZoneVerticesData, PaymentTypesData, ClassOfServiceData, AttributesData, DispatchDriverData
    // } = useSelector((store) => store.combinedata);
    // const OSRM_Username = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value;
    // const OSRM_Password = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value;
    // const ITCMapRawURL = selectedAff ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value : "https://itcmap.itcurves.us/api/map/";
    const addressComponenets = [
      { key: "city", value: "" },
      { key: "state", value: "" },
      { key: "zip", value: "" },
      { key: "formatted_address", value: ""},
      { key: "CompleteAddresscomponent", value: ""}
    ];

    // Function to lighten a hex color
    const lightenHexColor = (hex, percent) => {
      let num = parseInt(hex.slice(1), 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      G = (num >> 8 & 0x00FF) + amt,
      B = (num & 0x0000FF) + amt;

      return `#${(
            0x1000000 +
            (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
            (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
            (B < 255 ? (B < 1 ? 0 : B) : 255)
      )
      .toString(16)
      .slice(1)
      .toUpperCase()}`;
    };

    // Base gray color
    const baseGray = '#808080';
    // Lightened gray color
    const lighterGray = lightenHexColor(baseGray, 30); // 30% lighter

    //const lighterGray = '#D3D3D3';
    // Map style with the lighter gray color
    const mapStyles = [
      {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [{ color: '#E5E5E5' }], // Light gray for land
      },
      {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#A9CCE3' }], // Light blue for water
      },
      {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#CCCCCC' }], // Gray for roads
      },
      {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#D3D3D3' }], // Slightly darker gray for points of interest
      },
      {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#B3B3B3' }], // Medium gray for transit lines
      },
      {
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }],
      },
      {
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#f5f5f5' }],
      },
  ];



    useEffect(() => {
        setStops(busStops);
        plottedStops(busStops);

        if (polygon) {
          const polygonVertices = polygon.getPath().getArray().map(vertex => ({
            lat: vertex.lat(),
            lng: vertex.lng(),
          }));
          onSave(polygonVertices, busStops);
        }
    }, [busStops]);
  

//   const handleAddStop = (lat, lng) => {
//     setStops([...stops, [lat, lng]]);
//   };

//   const handleRemoveStop = (index) => {
//     setStops(stops.filter((_, i) => i !== index));
//   };

// useEffect(() => {
//     if (map !== undefined) {
//       if (stops?.length > 0) {
//         // Calculate the convex hull of the stops
//         const polygonPoints = hull(stops, 10).map(point => ({
//           lat: point[0],
//           lng: point[1],
//         }));
  
//         if (polygon) {
//           // Update the existing polygon
//           polygon.setPath(polygonPoints);
//         } else {
//           // Create the polygon with border only
//           const newPolygon = new window.google.maps.Polygon({
//             paths: polygonPoints,
//             strokeColor: "#FF0000", // Red border
//             strokeOpacity: 1.0,
//             strokeWeight: 2,
//             fillColor: "#FFFFFF", // White fill to ensure transparency
//             fillOpacity: 0.2,
//             editable: true, // Make the polygon editable
//             draggable: false, // Make the polygon draggable
//             map: map,
//           });
  
//           setPolygon(newPolygon);
//         }
//       } else if (polygon) {
//         // Clear the polygon if stops length is 0
//         polygon.setMap(null);
//         setPolygon(null);
//       }
//     }
//   }, [map, stops]);
  

  useEffect(() => {
    if (polygon) {
      window.google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
        if (onSave) {
          const updatedPolygon = polygon.getPath().getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));
          onSave(updatedPolygon, busStops);
        }
      });

      window.google.maps.event.addListener(polygon.getPath(), 'remove_at', () => {
        if (onSave) {
          const updatedPolygon = polygon.getPath().getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));
          onSave(updatedPolygon, busStops);
        }
      });

      window.google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
        if (onSave) {
          const updatedPolygon = polygon.getPath().getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));
          onSave(updatedPolygon, busStops);
        }
      });
    }
  }, [polygon, onSave, busStops]);


  useImperativeHandle(ref, () => ({
    saveMapData() {
      if (polygon) {
        const polygonVertices = polygon.getPath().getArray().map(vertex => ({
          lat: vertex.lat(),
          lng: vertex.lng(),
        }));
        onSave(polygonVertices, stops);
      }
    },
  }));


  // New Code
  const [savedLocalPolygoneDataFromDb, setSavedLocalPolygoneDataFromDb] = useState(SavedPolygone);
  const [localIsRestButtonClicked, setLocalIsRestButtonClicked] = useState(IsResetBtnClicked);
  const [localIsSearchButtonClicked, setLocalIsSearchButtonClicked] = useState(IsSearchButtonClicked);
  const [localIsReloadStopsButtonClicked, setLocalIsReloadStopsButtonClicked] = useState(IsReloadStopsButtonClicked);
  useEffect(() => {
    setLocalIsSearchButtonClicked(IsSearchButtonClicked);
  },[IsSearchButtonClicked])

  useEffect(() => {
    setSavedLocalPolygoneDataFromDb(SavedPolygone);
  },[SavedPolygone])



  useEffect(() => {
    setLocalIsReloadStopsButtonClicked(IsReloadStopsButtonClicked);
  },[IsReloadStopsButtonClicked])


  useEffect(() => {
    if (map && polygon) {
      // Get the vertices of the polygon
    const updatedPolygon = polygon.getPath().getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));

    const bounds = new window.google.maps.LatLngBounds();
    updatedPolygon.forEach(vertex => {
      bounds.extend(new window.google.maps.LatLng(vertex.lat, vertex.lng));
    });
    // console.log(updatedPolygon);
    // const southWest = {
    //   lat: bounds.getSouthWest().lat(),
    //   lng: bounds.getSouthWest().lng()
    // };

    // const northEast = {
    //   lat: bounds.getNorthEast().lat(),
    //   lng: bounds.getNorthEast().lng()
    // };
    // console.log(southWest, northEast)

    
    let polygonCoordinates = '';
  
    let reducedCoordinates = [];
    if(updatedPolygon?.length >=100){
    
      // const step = getSkippingLatLngNumberForGettingStops(updatedPolygon.length);// Math.ceil(updatedPolygon.length / 100);
      // for (let i = 0; i < updatedPolygon.length; i += step) {
      //   reducedCoordinates.push(updatedPolygon[i]);
      // }
      //polygonCoordinates = reducedCoordinates;
    }
    else{
    }
    reducedCoordinates = updatedPolygon;
    for(let y = 0; y < reducedCoordinates.length; y++)
    {
      if(y !== 0)
      {
        polygonCoordinates += " ";
      }
      polygonCoordinates += reducedCoordinates[y].lat + ' ' + reducedCoordinates[y].lng;
    }

    fetchBusStopsWithPolygon(polygonCoordinates);
    // fetchBusStops(southWest, northEast); // Call the function with updated coordinates

    onReloadStopsComplete();
    }
  }, [map, polygon, localIsReloadStopsButtonClicked]);
  
  const getSkippingLatLngNumberForGettingStops = (lengthOfList) => {
    try {
      if(lengthOfList >= 0 && lengthOfList <= 100){
        return 1;
      }
      else if(lengthOfList >= 100 && lengthOfList <= 300){
        return 5;
      }
      else if(lengthOfList >= 300 && lengthOfList <= 600){
        return 10;
      }
      else if(lengthOfList >= 600 && lengthOfList <= 900){
        return 15;
      }
    } catch (error) {
      
    }
  }

  useEffect(() => {
    if (map && localIsSearchButtonClicked) {
      handleResetPolygon();
      if (nameOfCityCounty) {
        drawPolygonByName(nameOfCityCounty, savedLocalPolygoneDataFromDb);
      }
      setLocalIsSearchButtonClicked(false);
    }
  }, [nameOfCityCounty, map, localIsSearchButtonClicked, savedLocalPolygoneDataFromDb]);

  // useEffect(() => {
  //   if (map) {
  //     if(nameOfCityCounty != undefined && nameOfCityCounty != "" && IsSearchButtonClicked == true){
  //       drawPolygonByName(nameOfCityCounty);
  //       IsSearchButtonClicked = false;
  //     }
  //   }
  // },[nameOfCityCounty])

  useEffect(() => {
    if (map) {
      if(nameOfCityCounty != undefined && nameOfCityCounty != ""){
        drawPolygonByName(nameOfCityCounty);
      }
    }
  }, [map]);

  function headersToObject(headers) {
    try{
      let result = {};
      for (let [key, value] of headers.entries()) {
        result[key] = value;
      }
      return result;
    }
    catch(err){console.log(err); return [];}
  };

  const ReverseGeoCode = async(Lat, Lng) => {
    try{
      let param_string = "&AppType=" + "Simulation_Agent";
      let ITCMapServiceURL = 'https://itcmapb.itcurves.us/api/Map/'; //Get this setting from ASCS Setting
      let ITCMapServiceUserName = 'SIV'; //Get this setting from ASCS Setting
      let ITCMapServicePassword = 'barwoodpass';  //Get this setting from ASCS Setting
      let myHeaders = new Headers();
      myHeaders.append("Authorization", 'Basic '+btoa(ITCMapServiceUserName + ":" + ITCMapServicePassword));
      myHeaders.append('Content-Type', 'application/json');
      let headersObj = headersToObject(myHeaders);
      let addressAPI = ITCMapServiceURL + 'geocode?latlng=' + Lat + ',' + Lng + param_string;
      let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
      return OSRMResponse;
      // $.ajax({
      //     url: ITCMapServiceURL + 'geocode?latlng=' + Lat + ',' + Lng + param_string,
      //     dataType: "json",
      //     beforeSend: function (xhr) {
      //         xhr.setRequestHeader("Authorization", "Basic " + btoa(ITCMapServiceUserName + ":" + ITCMapServicePassword));
      //     },
      //     crossDomain: true,
      //     success: function (response) {
      //         console.log(response);
      //     },
      //     error: function (jqXHR, textStatus, errorThrown) {
  
      //     }
      // });
    }
    catch(err){console.log(err);}
    
  }

  const fetchBusStopsWithPolygon = async (polygonCoordinates)=>{
    const query = `      
        [out:json];
        (
          // Find all bus stops within the polygon
          node["highway"="bus_stop"](poly:"${polygonCoordinates}");

          // Find all public transport platforms within the polygon
          node["public_transport"="platform"](poly:"${polygonCoordinates}");

          // Find all schools within the polygon
          node["amenity"="school"](poly:"${polygonCoordinates}");

          // Find all hospitals within the polygon
          node["amenity"="hospital"](poly:"${polygonCoordinates}");

          // Find all malls within the polygon
          node["shop"="mall"](poly:"${polygonCoordinates}");

          // Find all hotels within the polygon
          node["tourism"="hotel"](poly:"${polygonCoordinates}");

          // Find all restaurants within the polygon
          node["amenity"="restaurant"](poly:"${polygonCoordinates}");

          // Find all parks within the polygon
          node["leisure"="park"](poly:"${polygonCoordinates}");

          // Find all recreation centers within the polygon
          node["leisure"="recreation_ground"](poly:"${polygonCoordinates}");

          // Find all daycare centers within the polygon
          node["amenity"="childcare"](poly:"${polygonCoordinates}");

          // Find all gas stations within the polygon
          node["amenity"="fuel"](poly:"${polygonCoordinates}");

          // Find all cafes within the polygon
          node["amenity"="cafe"](poly:"${polygonCoordinates}");

          // Find all bars within the polygon
          node["amenity"="bar"](poly:"${polygonCoordinates}");

          // Find all fast food places within the polygon
          node["amenity"="fast_food"](poly:"${polygonCoordinates}");

          // Find all pharmacies within the polygon
          node["amenity"="pharmacy"](poly:"${polygonCoordinates}");

          // Find all police stations within the polygon
          node["amenity"="police"](poly:"${polygonCoordinates}");

          // Find all fire stations within the polygon
          node["amenity"="fire_station"](poly:"${polygonCoordinates}");

          // Find all banks within the polygon
          node["amenity"="bank"](poly:"${polygonCoordinates}");

          // Find all ATMs within the polygon
          node["amenity"="atm"](poly:"${polygonCoordinates}");

          // Find all post offices within the polygon
          node["amenity"="post_office"](poly:"${polygonCoordinates}");

          // Find all parking areas within the polygon
          node["amenity"="parking"](poly:"${polygonCoordinates}");

          // Find all cinemas within the polygon
          node["amenity"="cinema"](poly:"${polygonCoordinates}");

          // Find all museums within the polygon
          node["tourism"="museum"](poly:"${polygonCoordinates}");


        );
        out body;
        >;
        out skel qt;
      `;
      
      const url = `https://overpass-api.de/api/interpreter`;

      try {
        const response = await fetch(url, {
          method: "POST",
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `data=${encodeURIComponent(query)}`
        });
          const data = await response.json();
          const geocoder = new window.google.maps.Geocoder();
          let complAdr = "";
          let stops = data.elements.map(element => ({
            lat: element.lat,
            lon: element.lon,
            name: (element.tags.name ? element.tags.name : (element.tags["addr:street"] ? element.tags["addr:street"] : '')),
            street: (element.tags["addr:street"] ? element.tags["addr:street"] : ''),
            state: (element.tags["addr:state"] ? element.tags["addr:state"] : ''),
            zip: (element.tags["addr:postcode"] ? element.tags["addr:postcode"] : ''),
          }));
          
          for(let k = 0; k < stops.length; k++)
          {
            if(stops[k].name === '' && stops[k].street === '')
            {
              // console.log("went here", stops[k]);
              try{
                let reverseGeocodeResponse = await ReverseGeoCode(stops[k].lat, stops[k].lon);
                if(reverseGeocodeResponse && reverseGeocodeResponse.data.status.toUpperCase() === "OK")
                {
                  const addressComponents = reverseGeocodeResponse.data.results[0].address_components;
                  addressComponents.forEach(component => {
                    let state = "";
                    let zip = "";
                    if (component.types.includes("administrative_area_level_1")) {
                      state = component.short_name; // State
                      stops[k] = {
                        ...stops[k],
                        state: state
                      };
                    }
                    if (component.types.includes("postal_code")) {
                      zip = component.long_name; // ZIP code
                      stops[k] = {
                        ...stops[k],
                        zip: zip
                      };
                    }
                  });
                  stops[k] = {
                    ...stops[k],
                    street: reverseGeocodeResponse.data.results[0].formatted_address,
                    name: reverseGeocodeResponse.data.results[0].formatted_address
                  };
                   
                }
              }
              catch(err){
                await geocoder.geocode({ location: { lat: stops[k].lat, lng: stops[k].lon } }, (midResults, midStatus) => {
                  if (midStatus === window.google.maps.GeocoderStatus.OK) {
                    // console.log("got here", midResults, midStatus);
                    complAdr = "";
                    const midAddress = midResults[0].formatted_address;
      
                    let frmtAddr = addressComponenets.find(item => item.key === "formatted_address");
                    frmtAddr.value = midAddress;
      
                    const addressComponents = midResults[0].address_components;
                  
                    let city = "";
                    let state = "";
                    let zip = "";
      
                    
                    addressComponents.forEach(component => {
                      // console.log("got to address",addressComponenets);
                      if (component.types.includes("locality")) {
                        city = component.long_name; // City
                        let cty = addressComponenets.find(item => item.key === "city");
                        cty.value = city;
                      }
                      if (component.types.includes("administrative_area_level_1")) {
                        state = component.short_name; // State
                        let st = addressComponenets.find(item => item.key === "state");
                        st.value = state;
                        stops[k] = {
                          ...stops[k],
                          state: state
                        };
                      }
                      if (component.types.includes("postal_code")) {
                        zip = component.long_name; // ZIP code
                        let zp = addressComponenets.find(item => item.key === "zip");
                        zp.value = zip;
                        stops[k] = {
                          ...stops[k],
                          zip: zip
                        };
                      }
                      // console.log(stops[k], city, zip, state);
                    });
                    stops[k] = {
                      ...stops[k],
                      street: midAddress,
                      name: midAddress
                    };
      
                    //alert(city + " " + state + " " + zip);
                  } else {
                    stops[k] = {
                      ...stops[k],
                      name: k
                    };
                  }
                });
              }
              
              // await geocoder.geocode({ location: { lat: stops[k].lat, lng: stops[k].lon } }, (midResults, midStatus) => {
              //   if (midStatus === window.google.maps.GeocoderStatus.OK) {
              //     // console.log("got here", midResults, midStatus);
              //     complAdr = "";
              //     const midAddress = midResults[0].formatted_address;
    
              //     let frmtAddr = addressComponenets.find(item => item.key === "formatted_address");
              //     frmtAddr.value = midAddress;
    
              //     const addressComponents = midResults[0].address_components;
                 
              //     let city = "";
              //     let state = "";
              //     let zip = "";
    
                  
              //     addressComponents.forEach(component => {
              //       // console.log("got to address",addressComponenets);
              //       if (component.types.includes("locality")) {
              //         city = component.long_name; // City
              //         let cty = addressComponenets.find(item => item.key === "city");
              //         cty.value = city;
              //       }
              //       if (component.types.includes("administrative_area_level_1")) {
              //         state = component.short_name; // State
              //         let st = addressComponenets.find(item => item.key === "state");
              //         st.value = state;
              //         stops[k] = {
              //           ...stops[k],
              //           state: state
              //         };
              //       }
              //       if (component.types.includes("postal_code")) {
              //         zip = component.long_name; // ZIP code
              //         let zp = addressComponenets.find(item => item.key === "zip");
              //         zp.value = zip;
              //         stops[k] = {
              //           ...stops[k],
              //           zip: zip
              //         };
              //       }
              //       // console.log(stops[k], city, zip, state);
              //     });
              //     stops[k] = {
              //       ...stops[k],
              //       street: midAddress,
              //       name: midAddress
              //     };
    
              //     //alert(city + " " + state + " " + zip);
              //   } else {
    
              //   }
              // });
            }
          }
          // Check if the number of stops is greater than 100
          const getlimitedStops = stops.length > 100 ? stops.slice(0, 100) : stops;
        
          // Set the stops to the state

          setBusStops(getlimitedStops);
          if (onSearchComplete) {
            onSearchComplete();
          }
          console.log('Bus Stops ', getlimitedStops)
      } catch (error) {
          console.error('Error fetching bus stops:', error);
      }
  };

  const drawPolygonByName = (locationName, savedLocalPolygoneDataFromDb = "") => {
    if (!map) return;
    handleResetPolygon();


    const geocoder = new window.google.maps.Geocoder();
    let polygonCoords = [];
    //Extra 
    const RADIUS_IN_MILES = 5; // Radius in miles
    const RADIUS_IN_METERS = RADIUS_IN_MILES * 1609.34; // Convert miles to meters
    const NUM_VERTICES = 32; // Number of vertices for the polygon (higher number = smoother circle)
    // // 

    geocoder.geocode({ address: locationName }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        const coordinates = results[0].geometry.location;

        const distanceInKm = 5;
        const offset = distanceInKm * 0.009; // For latitude and longitude at the equator

        if(savedLocalPolygoneDataFromDb != "" 
          &&  savedLocalPolygoneDataFromDb != undefined
          && savedLocalPolygoneDataFromDb != null){
            let splittedCoordinates = savedLocalPolygoneDataFromDb.split(",");
            for (let i = 0; i < splittedCoordinates.length; i += 2){
              try {
                  let lat = parseFloat(splittedCoordinates[i]);
                  let lng = parseFloat(splittedCoordinates[i + 1]);
                  polygonCoords.push({ lat: lat, lng: lng });
              } catch (error) {
                
              }
        }
      }
      else{
     
        // Define expanded polygon vertices
        polygonCoords = [
          { lat: coordinates.lat() + offset, lng: coordinates.lng() - offset },
          { lat: coordinates.lat() + offset, lng: coordinates.lng() + offset },
          { lat: coordinates.lat() - offset, lng: coordinates.lng() + offset },
          { lat: coordinates.lat() - offset, lng: coordinates.lng() - offset }
        ];
        
      }

        // Create and display the polygon
        const newPolygon = new window.google.maps.Polygon({
          paths: polygonCoords,
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          editable: true
        });

        newPolygon.setMap(map);
        setPolygon(newPolygon);

        //Get Mid Address\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
        try {
          const midLat = (polygonCoords[0].lat + polygonCoords[1].lat + polygonCoords[2].lat + polygonCoords[3].lat) / 4;
          const midLng = (polygonCoords[0].lng + polygonCoords[1].lng + polygonCoords[2].lng + polygonCoords[3].lng) / 4;
          const midpoint = { lat: midLat, lng: midLng };

          // Reverse geocode the midpoint to find the address
          let complAdr = "";
          geocoder.geocode({ location: midpoint }, (midResults, midStatus) => {
            if (midStatus === window.google.maps.GeocoderStatus.OK) {
              complAdr = "";
              const midAddress = midResults[0].formatted_address;

              let frmtAddr = addressComponenets.find(item => item.key === "formatted_address");
              frmtAddr.value = midAddress;

              const addressComponents = midResults[0].address_components;
             
              let city = "";
              let state = "";
              let zip = "";

              
              addressComponents.forEach(component => {
                if (component.types.includes("locality")) {
                  city = component.long_name; // City
                  let cty = addressComponenets.find(item => item.key === "city");
                  cty.value = city;
                  complAdr += "city=" + city;
                }
                if (component.types.includes("administrative_area_level_1")) {
                  state = component.short_name; // State
                  let st = addressComponenets.find(item => item.key === "state");
                  st.value = state;
                  complAdr += "!state=" + state;
                }
                if (component.types.includes("postal_code")) {
                  zip = component.long_name; // ZIP code
                  let zp = addressComponenets.find(item => item.key === "zip");
                  zp.value = zip;
                  complAdr += "!zip=" + zip;
                }
              });
              complAdr += "!completeAddress=" + midAddress;
              complAdr += "!lat=" + midLat;
              complAdr += "!lng=" + midLng;
              
              let completeAddress = addressComponenets.find(item => item.key === "CompleteAddresscomponent");
              completeAddress.value = complAdr;
              AddressComponentData(addressComponenets);

              //alert(city + " " + state + " " + zip);
            } else {

            }
          });
        } catch (error) {
          
        }
        //Get Mid Address\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


        // Center map and zoom in to fit the polygon
        const bounds = new window.google.maps.LatLngBounds();
        polygonCoords.forEach(coord => {
          bounds.extend(new window.google.maps.LatLng(coord.lat, coord.lng));
        });
        map.fitBounds(bounds);
       


        // const southWest = {
        //     lat: bounds.getSouthWest().lat(),
        //     lng: bounds.getSouthWest().lng()
        //   };
    
        //   const northEast = {
        //     lat: bounds.getNorthEast().lat(),
        //     lng: bounds.getNorthEast().lng()
        //   };
        //   console.log(southWest, northEast)

        // fetchBusStops(southWest, northEast);
        let polygonCoordinates = '';
       
        let reducedCoordinates = [];
        if(polygonCoords?.length >=100){
          // const step = getSkippingLatLngNumberForGettingStops(polygonCoords.length);// Math.ceil(updatedPolygon.length / 100);
          // for (let i = 0; i < polygonCoords.length; i += step) {
          //   reducedCoordinates.push(polygonCoords[i]);
          // }
          //polygonCoordinates = reducedCoordinates;
        }
        else{
        }
        
        reducedCoordinates = polygonCoords;
        for(let y = 0; y < reducedCoordinates.length; y++)
        {
          if(y !== 0)
          {
            polygonCoordinates += " ";
          }
          polygonCoordinates += reducedCoordinates[y].lat + ' ' + reducedCoordinates[y].lng;
        }
       

        fetchBusStopsWithPolygon(polygonCoordinates);
      } else {
        console.log('Geocode was not successful for the following reason: ' + status);
      }
    });
  };


    const fetchBusStops = async (southWest, northEast) => {
      const query = `
      [out:json];
      (
        // Find all bus stops within the bounding box
        node["highway"="bus_stop"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        // Find all public transport platforms within the bounding box
        node["public_transport"="platform"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        // Find all schools within the bounding box
        node["amenity"="school"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        // Find all hospitals within the bounding box
        node["amenity"="hospital"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        // Find all malls within the bounding box
        node["shop"="mall"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        // Find all hotels within the bounding box
        node["tourism"="hotel"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        // Find all restaurants within the bounding box
        node["amenity"="restaurant"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        // Find all parks within the bounding box
        node["leisure"="park"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        // Find all recreation centers within the bounding box
        node["leisure"="recreation_ground"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        // Find all daycare centers within the bounding box
        node["amenity"="childcare"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        // Find all gas stations within the bounding box
        node["amenity"="fuel"](${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng});

        
      );
      out body;
      >;
      out skel qt;
  `;
        
        const url = `https://overpass-api.de/api/interpreter?data=${encodeURIComponent(query)}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            const stops = data.elements.map(element => ({
              lat: element.lat,
              lon: element.lon,
            }));
          
            // Check if the number of stops is greater than 100
            const getlimitedStops = stops.length > 100 ? stops.slice(0, 100) : stops;
          
            // Set the stops to the state
            setBusStops(getlimitedStops);
            console.log('Bus Stops ', getlimitedStops)
        } catch (error) {
            console.error('Error fetching bus stops:', error);
        }
    };

  useEffect(() => {
    // if (IsResetBtnClicked) 
    // {
    //   handleResetPolygon();
    // }
    setLocalIsRestButtonClicked(IsResetBtnClicked);
  }, [IsResetBtnClicked]);

  useEffect(() => {
    if (map && localIsRestButtonClicked) {
      handleResetPolygon();
      
    }
  },[localIsRestButtonClicked])

  const handleResetPolygon = () => {
    if (polygon) {
      polygon.setMap(null);
      setPolygon(null);
      setStops(null);
      setBusStops(null);
      if(onResetComplete){
        onResetComplete();
      }
    }
    else{
      setPolygon(null);
      setStops(null);
      setBusStops(null);
      if(onResetComplete){
        onResetComplete();
      }
    }
  };


  // New Code


  return (
    <div id="mapControlRCZ" style={{ height: '100%', width: '100%' }} ref={mapRef}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI', libraries: 'drawing' }} yesIWantToUseGoogleMapApiInternals defaultCenter={center} defaultZoom={zoom}
        styles={mapStyles}
        onGoogleApiLoaded={({ map, maps }) => {
            map.setOptions({ styles: mapStyles });
            setMap(map)
            console.log('Map:', map);
            console.log('Maps:', maps);
        }}>
        {stops?.length > 0 && stops.map((stop, index) => (
        <StopMarker
            key={index}
            lat={stop.lat} // Use stop.lat for latitude
            lng={stop.lon} // Use stop.lon for longitude
            icon={PUIcon} // Use the imported PUIcon as the icon
        />
        ))}
      </GoogleMapReact>
    </div>
  );
});

export default RCZControlMap;
